"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _StackedDrawer = _interopRequireDefault(require("../StackedDrawer"));

var _Drawer = _interopRequireDefault(require("../Drawer"));

var _index = require("./index");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var MockDrawerStack = function MockDrawerStack(_ref) {
  var parentId = _ref.parentId,
      showOnRender = _ref.showOnRender,
      childId = _ref.childId,
      children = _ref.children;

  var _useDrawerStack = (0, _index.useDrawerStack)(),
      showDrawer = _useDrawerStack.showDrawer;

  (0, _react.useEffect)(function () {
    if (showOnRender) showDrawer(parentId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return showDrawer(parentId);
    },
    "data-testid": "show-MockParentDrawer"
  }, "Show MockParentDrawer"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return showDrawer(childId);
    },
    "data-testid": "show-".concat(childId)
  }, "Show ChildDrawer"), /*#__PURE__*/_react["default"].createElement(_StackedDrawer["default"], {
    id: parentId
  }, /*#__PURE__*/_react["default"].createElement(_Drawer["default"].Header, {
    title: "MockParentDrawer"
  }), /*#__PURE__*/_react["default"].createElement(_Drawer["default"].Content, null, children)));
};

MockDrawerStack.propTypes = {
  parentId: _propTypes.string.isRequired,
  showOnRender: _propTypes.bool,
  childId: _propTypes.string,
  children: _propTypes.node
};
MockDrawerStack.defaultProps = {
  showOnRender: true,
  childID: ''
};

var _default = (0, _index.withDrawerStack)(MockDrawerStack);

exports["default"] = _default;